import { Icon } from "@/components/Icon";
import isEqual from "lodash/isEqual";
import { PropsWithChildren, useEffect, useState } from "react";
import { FilterItem, FilterPopup } from "../FilterPopup";
import styles from "./styles.module.scss";
type FilterLayoutProps = {
  onChange?: (value: Record<string, string[]>) => void;
  filters?: Record<string, string[]>;
  items?: FilterItem[];
};
export function FilterLayout(props: PropsWithChildren<FilterLayoutProps>) {
  const [filterVisible, setFilterVisible] = useState<boolean>(false);
  const [_filters, setFilters] = useState<Record<string, string[]>>({});
  const onSubmit = (filters: Record<string, string[]>) => {
    setFilterVisible(false);
    setFilters(filters);
    typeof props.onChange === "function" && props.onChange(filters);
  };
  useEffect(() => {
    if (Array.isArray(props.filters) && isEqual(props.filters, _filters)) {
      setFilters(props.filters);
    }
  }, [props.filters]);
  return <div className={styles.filter} data-sentry-component="FilterLayout" data-sentry-source-file="index.tsx">
      {/* TODO 优化列表选项渲染 */}
      <div className={styles.filterOrders}>{props.children}</div>
      <div className={styles.filterTags}></div>
      {Array.isArray(props.items) ? <div onClick={() => setFilterVisible(true)}>
          <Icon name="filter" size="20px" />
        </div> : null}

      <FilterPopup visible={filterVisible} items={props.items ? props.items : []} filters={_filters ? _filters : {}} onSubmit={onSubmit} onCancel={() => setFilterVisible(false)} data-sentry-element="FilterPopup" data-sentry-source-file="index.tsx" />
    </div>;
}